<div [class.filter-has-no-matching-items]="! state?.canRefine">
    <app-refinement-list-contents *ngIf="state?.items as items"
                                  [items]="items"
                                  [localisedAttribute]="localisedAttribute"
                                  (toggle)="toggleItem($event)"
    ></app-refinement-list-contents>

    <app-button *ngIf="state?.canToggleShowMore"
                theme="link"
                size="smaller"
                layout="label-icon"
                [icon]="state?.isShowingMore ? 'chevron-up' : 'chevron-down'"
                (clicked)="state?.toggleShowMore()"
    >
        <span [hidden]="state?.isShowingMore">{{ 'products.show-more' | translate }}</span>
        <span [hidden]="! state?.isShowingMore">{{ 'products.show-less' | translate }}</span>
    </app-button>
</div>
